import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from 'sagas';
import appReducer from './app';
import backendReducer from './backend';
import backyardReducer from './backyard';
import flashMessageReducer from './flashMessage';
import surveyReducer from './survey';

export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

interface ExtendedWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
}
declare let window: ExtendedWindow;

const composeReduxDevToolsEnhancers =
  (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  combineReducers({
    router: connectRouter(history),
    app: appReducer,
    flashMessage: flashMessageReducer,
    survey: surveyReducer,
    backend: backendReducer,
    backyard: backyardReducer,
  }),
  composeReduxDevToolsEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware)),
);

sagaMiddleware.run(rootSaga);

export default store;
